import { isBrowser } from "./Browser";
import { isMobile } from "react-device-detect";

export const LOGIN_WITH_FACEBOOK = "loginWithFacebook";
export const LOGIN_WITH_TWITTER = "loginWithTwitter";
export const LOGIN_WITH_EMAIL = "loginWithEmail";
export const NEW_DATE_SELECTOR = "newDateSelector";
export const RENDER_NEW_SCHEDULED_SECTION = "renderNewScheduledSection";
export const SHOW_BLOG_SWIPER = "showBlogSwiper";
export const DISMISS_CONTINUE_IN_APP = "dismissContinueInApp";
export const SPEAKER_NAMES = "speakerNames";
export const SUBSCRIPTION_DEBUGGING = "subscriptionDebugging";
export const STRIPE_CUSTOMER_ADMIN = "stripeCustomerAdmin";
export const ONE_PLAN = "onePlan";
export const CHANGE_PLAN = "changePlan";
export const CHAT_AI = "chatAI";
export const CHAT_AI_DEBUG_MODE = "chatAIDebugMode";
export const WORDS_ON_THE_STREET = "wordsOnTheStreet";

export const isFeatureEnabled = (featureName) => {
  if (!isBrowser()) {
    return false;
  }
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has(featureName)) {
    return true;
  }
  return localStorage.getItem(featureName) === "true";
};

export const enableFeature = (featureName) => {
  if (!isBrowser()) {
    return;
  }
  localStorage.setItem(featureName, "true");
};

export const disableFeature = (featureName) => {
  if (!isBrowser()) {
    return;
  }
  localStorage.setItem(featureName, "false");
};

export const isAndroidOrIOSDevice = () => {
  return isMobile;
};
